import * as localforage from 'localforage';

export const indexedDBInstance = localforage.createInstance({
  name: 'filecache',
});
